import { createRenderer } from './render-document.js';
/** Render an upgraded, workspace-resolved document without fetching or loading files. */
export const createMarkdownFromAsyncApi = async (document, options) => createRenderer(document).render(options);
